import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Axioshelper } from '../../../../shared/common/helper/axios-helper';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { fuseAnimations } from '@fuse/animations';
import { default as _rollupMoment } from 'moment';
import * as _moment from 'moment';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// const BASE_URL = 'https://whatsdare.com/api/v4/';
// const API_KEY = 'wRTp_bx3_riFPpmHdYWF';

@Component({
  selector: 'app-project-commits',
  templateUrl: './project-commits.component.html',
  styleUrls: ['./project-commits.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class ProjectCommitsComponent implements OnInit {

  users: SelectItem[] = [];
  target_type: SelectItem[] = [];
  branches: SelectItem[] = [];
  totalBranchCommits = [];
  project_list: SelectItem[] = [];
  pro_repo_list: SelectItem[] = [];
  pro_members: SelectItem[] = [];
  title = 'report-sample';
  totalContribution = 0;
  totalCreatedContribution = [];
  totalPushedContribution = [];
  totalClosedContribution = [];
  totalopenedContribution = [];
  totalReopenedContribution = [];
  totalMergedContribution = [];
  totalCommentedContribution = [];
  totalProjectCommits = [];
  memberFilterItems: SelectItem[] = [];
  data: any;
  totalCommitsUser = [];
  proMemberFilter = new Set();

  currentUser: string;
  graphData: any;

  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  }
  currentUserId: any;
  fromDate: any;
  toDate: any;
  startDate: any;
  endDate: any;
  selectedUser: any;
  eventData: any;
  tabIndex = new FormControl(0);
  month = new FormControl(moment());
  totalRecords: number;
  BASE_URL: any;
  API_KEY: any;
  dataSettings: any;
   

  constructor(private _axiosHelper: Axioshelper,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration
  ) {
     
  }

  async ngOnInit(): Promise<void> {

    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    this.dataSettings = await query.find();
    this.BASE_URL = this.dataSettings[0].get('gitLabDetails').BASE_URL;
    this.API_KEY = this.dataSettings[0].get('gitLabDetails').API_KEY;

    this.proMemberFilter.clear();

    let getURL = this.BASE_URL + 'groups?&private_token=' + this.API_KEY + '&per_page=500';
    var getProjectGroups = await this._axiosHelper.getGitlabDetails(getURL);
    getProjectGroups.forEach(group => {
      this.project_list.push({ label: group.name, value: { id: group.id, name: group.name, full_path: group.full_path } });
    });

    // Make a request for a user with a given ID
    let getUserURL = this.BASE_URL + "users?active=true&private_token=" + this.API_KEY + "&order_by=name&sort=asc&per_page=500";
    let userDDresult = await this._axiosHelper.getGitlabDetails(getUserURL);
    userDDresult.forEach(user => {
      this.users.push({ label: user.name, value: { id: user.id, name: user.name, email: user.email, user_name: "fullstack/imperialdade/web", avatar_url: user.avatar_url } })
    });

  }

  tabChange(event) {
    if (event == 1) {
      this.tabIndex.setValue(0);
    }
  }

  async getProjectRepository(eventData) {
    this.pro_repo_list = [];
    this.branches = [];
    this.totalBranchCommits = [];
    let getProjectRepo = this.BASE_URL + 'groups/' + eventData.value.id + '?&private_token=' + this.API_KEY + '&per_page=500';
    let projectRepos = await this._axiosHelper.getSingleGitlabDeatails(getProjectRepo);
    projectRepos.projects.forEach(project => {
      this.pro_repo_list.push({ label: project.name, value: { id: project.id, repo_url: project.http_url_to_repo } })
    });
  }

  async getProjectBranches(eventData) {
    this.branches = [];
    this.totalBranchCommits = [];
    let getProjectBranches = this.BASE_URL + 'projects/' + eventData.value.id + '/repository/branches?&private_token=' + this.API_KEY + '&per_page=500';
    let projectBranches = await this._axiosHelper.getSingleGitlabDeatails(getProjectBranches);

    projectBranches.forEach(branch => {
      this.branches.push({ label: branch.name, value: { name: branch.name, projectId: eventData.value.id } });
    });
  }

  async getBranchCommits(eventData) {
    this.spinner.show();
    this.eventData = eventData;
    this.proMemberFilter.clear();
    this.memberFilterItems = [];
    this.totalBranchCommits = [];
    this.totalCommitsUser = [];

    let d = new Date();
    let startDate = (new Date(d.setDate(d.getDate() - 365))).toISOString();;
    let toDate = new Date().toISOString();;

    // let getBranchCommits = this.BASE_URL + 'projects/' + eventData.value.projectId + '/repository/commits?&private_token=' + this.API_KEY + '&ref_name=' + eventData.value.name +
    //   '&since=2019-06-01T00:00:00Z&until=2020-06-30T00:00:00Z&per_page=100';

    let getBranchCommits = this.BASE_URL + 'projects/' + eventData.value.projectId + '/repository/commits?&private_token=' + this.API_KEY + '&ref_name=' + eventData.value.name +
      '&since=' + startDate + '&until=' + toDate + '&per_page=100' + '&with_stats=true';

    var projectBranchCommint = await this._axiosHelper.getGitlabDetails(getBranchCommits);

    projectBranchCommint.forEach(commit => {
      if (!this.proMemberFilter.has(commit.committer_email)) {
        this.proMemberFilter.add(commit.committer_email)
        this.memberFilterItems.push({ label: commit.committer_email, value: commit.committer_email })
      }
    });

    for (let user of this.proMemberFilter) {
      let additions = 0;
      let deletions = 0;
      var commitCount = projectBranchCommint.filter(i => i.committer_email === user).length;

      let commits = projectBranchCommint.filter(i => i.committer_email === user);
      commits.forEach(element => {
        additions += element.stats.additions;
        deletions += element.stats.deletions;
      });
      this.totalCommitsUser.push({
        user: user,
        commitCount: commitCount,
        additions: additions,
        deletions: deletions,
        total: additions + deletions
      });

    }
    this.totalBranchCommits = projectBranchCommint;
    this.spinner.hide();
  }



  async getallUserContribution(selectedUser) {
    this.totalRecords = 0;
    this.selectedUser = selectedUser;
    this.currentUser = selectedUser.name;
    this.currentUserId = selectedUser.id;
    this.emptyArrayOnChange();

    let datePipe = new DatePipe('en-US');
    let d = new Date();
    let startingDate = new Date(d.setDate(d.getDate() - 365));
    let startDate = datePipe.transform(startingDate, 'yyyy-MM-dd');
    let toDate = datePipe.transform(new Date(), 'yyyy-MM-dd');
    let getURL = this.BASE_URL + 'users/' + selectedUser.id + '/events?private_token=' + this.API_KEY + '&after=' + startDate + '&before=' + toDate + '&per_page=1000&sort=asc';

    this.getCreatedContribution(getURL);
    this.getPushedContribution(getURL);
    this.getClosedContribution(getURL);
    this.getReopenedContribution(getURL);
    this.getMergedContribution(getURL);
    this.geCommenttedContribution(getURL);

  }

  async getCreatedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=created');
    this.totalCreatedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalCreatedContribution.length;
  }

  async getPushedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=pushed');
    this.totalPushedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalPushedContribution.length;
  }

  async getClosedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=closed');
    this.totalClosedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalClosedContribution.length;
  }

  async getReopenedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=reopened');
    this.totalReopenedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalReopenedContribution.length;
  }

  async getMergedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=merged');
    this.totalMergedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalMergedContribution.length;
  }

  async geCommenttedContribution(url) {
    var conResults = await this._axiosHelper.getGitlabDetails(url + '&action=commented');
    this.totalCommentedContribution = conResults;
    this.getGraphValue();
    this.totalRecords += this.totalCommentedContribution.length;
  }

  getGraphValue() {
    this.graphData = {
      labels: ['Created', 'Pushed', 'Closed', 'Re-Opened', 'Merged', 'Commented'],
      datasets: [
        {
          label: 'Contribution',
          backgroundColor: '#42A5F5',
          borderColor: '#1E88E5',
          data: [this.totalCreatedContribution.length, this.totalPushedContribution.length,
          this.totalClosedContribution.length,
          this.totalReopenedContribution.length,
          this.totalMergedContribution.length,
          this.totalCommentedContribution.length]
        }
      ]
    };
  }

  emptyArrayOnChange() {
    this.totalCreatedContribution = [];
    this.totalPushedContribution = [];
    this.totalClosedContribution = [];
    this.totalopenedContribution = [];
    this.totalReopenedContribution = [];
    this.totalMergedContribution = [];
    this.totalCommentedContribution = [];
    // this.project_list = [];
  }

  async getBranchCommitsByFilter() {
    if (this.startDate != undefined) {
      this.proMemberFilter.clear();
      this.memberFilterItems = [];
      this.totalBranchCommits = [];
      this.totalCommitsUser = [];

      let startDate = (new Date(this.startDate)).toISOString();
      let toDate = new Date(this.endDate != undefined ? this.endDate : new Date()).toISOString();;

      let getBranchCommits = this.BASE_URL + 'projects/' + this.eventData.value.projectId + '/repository/commits?&private_token=' + this.API_KEY + '&ref_name=' +
        this.eventData.value.name + '&since=' + startDate + '&until=' + toDate + '&per_page=100';

      var projectBranchCommint = await this._axiosHelper.getGitlabDetails(getBranchCommits);
      projectBranchCommint.forEach(commit => {
        if (!this.proMemberFilter.has(commit.committer_email)) {
          this.proMemberFilter.add(commit.committer_email)
          this.memberFilterItems.push({ label: commit.committer_email, value: commit.committer_email })
        }
      });
      for (let user of this.proMemberFilter) {
        var commitCount = projectBranchCommint.filter(i => i.committer_email === user).length;
        this.totalCommitsUser.push({ user: user, commitCount: commitCount });
      }
      this.totalBranchCommits = projectBranchCommint;
    }
    else {
      this.toastr.warning('Please enter the start date');
    }
  }

  clearProjectFilter() {
    this.getBranchCommits(this.eventData);
  }

  async getUserContributionFilter() {

    if (this.fromDate != undefined) {
      this.emptyArrayOnChange();
      let datePipe = new DatePipe('en-US');
      let startDate = datePipe.transform(this.fromDate, 'yyyy-MM-dd');
      let toDate = datePipe.transform(this.toDate ? this.toDate : new Date(), 'yyyy-MM-dd');
      let getURL = this.BASE_URL + 'users/' + this.currentUserId + '/events?private_token=' + this.API_KEY + '&after=' + startDate + '&before=' + toDate + '&per_page=100&sort=asc';

      this.getCreatedContribution(getURL);
      this.getPushedContribution(getURL);
      this.getClosedContribution(getURL);
      this.getReopenedContribution(getURL);
      this.getMergedContribution(getURL);
      this.geCommenttedContribution(getURL);
    }
    else {
      this.toastr.warning('Please enter the start date');
    }
  }


  clearFilter() {
    this.getallUserContribution(this.selectedUser);
  }

  getToday(): Date {
    return new Date(Date.now() - 864e5);
  }


}
